import BaseStore from '@/store/baseStore'
import { sortBy } from 'lodash'
import generateBaseImportFromStage from '@/store/baseImportFromStage'
import api from '../api/api'

export const namespaced = true

const baseURI = '/reinforcement/'

const baseStore = new BaseStore(baseURI)
const baseImportFromStage = generateBaseImportFromStage({})

const getDefaultState = () => ({
  ...structuredClone(baseStore.state),
  ...structuredClone(baseImportFromStage.state),
  generateLoading: false,
  writeLoading: false,
  deleteAllLoading: false,
  deleteAllDialog: false
})

export const state = getDefaultState()

export const mutations = {
  ...baseStore.mutations,
  ...baseImportFromStage.mutations,
  TOGGLE_GENERATE_LOADING(state) {
    state.generateLoading = !state.generateLoading
  },
  TOGGLE_WRITE_LOADING(state) {
    state.writeLoading = !state.writeLoading
  },
  TOGGLE_DELETE_ALL_LOADING(state) {
    state.deleteAllLoading = !state.deleteAllLoading
  },
  TOGGLE_DELETE_ALL_DIALOG(state) {
    state.deleteAllDialog = !state.deleteAllDialog
  }
}

export const actions = {
  ...baseStore.actions,
  ...baseImportFromStage.actions,
  async generateNewSchema({ commit }, { reinforcementId, name }) {
    commit('TOGGLE_GENERATE_LOADING')
    const url = '/stab_schematisations/generate/'
    try {
      const response = await api.post(url, { reinforcement: reinforcementId, name })
      commit('stabSchematisation/ADD_ITEM', response.data, { root: true })
      return response.data
    } catch (e) {
      console.log(e)
      return null
    } finally {
      commit('TOGGLE_GENERATE_LOADING')
    }
  },
  async importReinforcementsFromStage(
    { commit, dispatch },
    { sourceSchematisationStageId, targetSchematisationStageId }
  ) {
    try {
      commit('TOGGLE_IMPORT_FROM_STAGE_LOADING')
      const { imported_reinforcements, imported_reinforcement_points } = await dispatch(
        'importFromStage',
        {
          import_option: {
            source_stab_schematisation_stage_id: sourceSchematisationStageId,
            target_stab_schematisation_stage_id: targetSchematisationStageId
          },
          stab_schematisation_stage: targetSchematisationStageId
        }
      )
      commit('SET_ITEMS', imported_reinforcements)
      commit('reinforcementPoint/SET_ITEMS', imported_reinforcement_points, { root: true })
    } catch (e) {
      console.log(e)
    } finally {
      commit('TOGGLE_IMPORT_FROM_STAGE_LOADING')
    }
  },
  async update(context) {
    let url = baseURI + 'bulk_update/'
    let updatedObj = context.state.dirtyItems
      ? context.state.dirtyItems.filter((dirtyItem) => dirtyItem.id > 0)
      : []
    if (updatedObj.length) {
      const clonedUpdatedObj = [...updatedObj]
      clonedUpdatedObj.forEach((obj) => {
        delete obj.reinforcement_setting
      })
      await api.patch(url, clonedUpdatedObj)
    }
  },
  async deleteAll({ commit }, stabSchematisationStageId) {
    const url = baseURI + stabSchematisationStageId + '/delete_all/'
    try {
      commit('TOGGLE_DELETE_ALL_LOADING')
      await api.delete(url)
      commit('SET_ITEMS', [])
    } catch (e) {
      console.log(e)
    } finally {
      commit('TOGGLE_DELETE_ALL_LOADING')
    }
  },
  toggleDeleteAllDialog({ commit }) {
    commit('TOGGLE_DELETE_ALL_DIALOG')
  }
}

export const getters = {
  sortedReinforcement(state) {
    return sortBy(state.items, 'id')
  },
  shownSoilType: (state, getters, rootState) => (soilTypeId) => {
    return rootState.baseSoilType.items.find((baseSoilType) => baseSoilType.id === soilTypeId)?.name
  },
  getReinforcementById: (state) => (reinforcementId) => {
    return state.items.find((reinforcement) => reinforcement.id === reinforcementId)
  }
}
